import { createAction } from '@ngrx/store';

export const setAppLoader = createAction('[App] Set App Loader', (isLoading: boolean) => ({ isLoading }));
